import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'

import TextField from 'material-ui/TextField'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { balance } from 'selectors/transactions'

let select = dirtyRead(
	(state, props) => ({
		paymentTransaction: doc(state, props.objectID)
	})
)

export class PaidAmount extends Component{
	render(){
		let { props } = this
		return(
			<div>
				<TextField
					underlineStyle={{
						borderBottom: "0px solid #b0bec4"
					}}
					floatingLabelText={props.paymentTransaction.amount?"Amount":"Input amount"}

					hintStyle={{fontStyle: "italic", fontSize: "14px"}}
					floatingLabelStyle={{
						fontWeight: "100",
						fontSize: "14px"
					}}
					underlineDisabledStyle={{borderBottom: "0px solid"}}
					multiLine = {false}
					style={{
						  position: "relative"
						, top: "-15px"
						, color: "#000"
						, width: "140px"
					}}
					key={props.paymentTransaction.amount}
					defaultValue={(props.paymentTransaction.amount || props.balance || 0).toFixed(2)}
					onBlur={(evt) =>{
						let amount = parseFloat(evt.target.value.replace(',',''))
						props.STAGE({
							_id: props.objectID
							, amount: +amount
						})
					}}
				/>
			</div>
		)
	}
}

export default connect(select, dataActions)(PaidAmount)



// WEBPACK FOOTER //
// ./src/routes/manager/transactionForm/PaymentAmount.js